import { featuredExposures } from '@/mocks/gossipContent';
import Reveal from '@/components/base/Reveal';

export default function FeaturedSection() {
  const [lead, ...sides] = featuredExposures;

  return (
    <section id="featured" className="bg-background-50">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-12 md:py-16">
        <Reveal>
          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
            <div>
              <div className="flex items-center gap-2 text-xs">
                <span className="font-heading text-primary-600 tracking-widest">CH.02</span>
                <span className="h-px w-8 bg-background-300" />
                <span className="text-foreground-500">黑料曝光 · 证据链拆解</span>
              </div>
              <h2 className="font-heading text-2xl md:text-4xl font-bold mt-3 tracking-tight">
                封面大瓜<span className="text-primary-600">与</span>侧栏档案
              </h2>
            </div>
            <p className="max-w-md text-sm text-foreground-600 leading-relaxed">
              每则料都先摆素材、再谈立场。录音、截图与录屏按时间轴归档，等你亲自核对结论。
            </p>
          </div>
        </Reveal>

        <div className="mt-7 grid grid-cols-1 lg:grid-cols-12 gap-5">
          {/* 封面大瓜 */}
          <Reveal className="lg:col-span-7">
            <article className="group flex h-full flex-col overflow-hidden rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-300 transition-colors">
              <a href="#featured" className="relative block overflow-hidden">
                <div className="aspect-[3/2] w-full overflow-hidden">
                  <img
                    src={lead.image}
                    alt={lead.title}
                    className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-[1.03]"
                  />
                </div>
                <span className="absolute left-3 top-3 rounded-full bg-foreground-950/85 px-3 py-1 text-xs font-medium text-background-50">
                  封面大瓜
                </span>
              </a>
              <div className="flex flex-1 flex-col p-5 md:p-6">
                <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                  <span className="text-accent-700 font-medium">{lead.kicker}</span>
                  <span className="text-background-300">·</span>
                  <span>{lead.evidence}</span>
                </div>
                <h3 className="font-heading text-xl md:text-2xl font-bold leading-snug mt-3">
                  <a href="#featured" className="hover:text-primary-700 transition-colors">
                    {lead.title}
                  </a>
                </h3>
                <p className="mt-3 text-sm text-foreground-700 leading-relaxed">{lead.summary}</p>
                <div className="mt-auto flex flex-wrap items-center gap-3 pt-5 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line w-4 h-4 flex items-center justify-center" />
                    {lead.reads}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-chat-3-line w-4 h-4 flex items-center justify-center" />
                    {lead.comments}
                  </span>
                  <a
                    href="#featured"
                    className="ml-auto inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 text-background-50 px-3.5 py-1.5 text-xs hover:bg-primary-600 transition-colors"
                  >
                    查看证据链
                    <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
                  </a>
                </div>
              </div>
            </article>
          </Reveal>

          {/* 侧栏档案 */}
          <div className="lg:col-span-5 grid grid-cols-1 gap-5">
            {sides.map((it, idx) => (
              <Reveal key={it.id} delay={idx * 60}>
                <article className="group flex gap-4 rounded-md bg-background-100 border border-background-200/70 p-3 hover:border-primary-300 transition-colors">
                  <a href="#featured" className="shrink-0 overflow-hidden rounded-md w-28 md:w-36">
                    <div className="aspect-[4/3] w-full overflow-hidden">
                      <img
                        src={it.image}
                        alt={it.title}
                        className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-[1.06]"
                      />
                    </div>
                  </a>
                  <div className="flex min-w-0 flex-1 flex-col">
                    <span className="inline-flex items-center gap-1.5 whitespace-nowrap text-[11px] text-accent-700">
                      {it.kicker}
                      <span className="h-px w-4 bg-background-300" />
                    </span>
                    <h3 className="font-heading text-[15px] font-semibold leading-snug mt-1.5">
                      <a href="#featured" className="group-hover:text-primary-700 transition-colors line-clamp-2">
                        {it.title}
                      </a>
                    </h3>
                    <p className="mt-1.5 text-xs text-foreground-600 line-clamp-2 hidden sm:block">{it.summary}</p>
                    <div className="mt-auto flex flex-wrap items-center gap-2 pt-2 text-[11px] text-foreground-500">
                      <span className="inline-flex items-center gap-1">
                        <i className="ri-eye-line w-4 h-4 flex items-center justify-center" />
                        {it.reads}
                      </span>
                      <span className="inline-flex items-center gap-1">
                        <i className="ri-file-list-3-line w-4 h-4 flex items-center justify-center" />
                        {it.evidence}
                      </span>
                    </div>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}